








// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator';
import EditDrawer from '@/components/shared/EditDrawer.vue'
import deepEqual from 'deep-equal'
import cloneDeep from 'clone-deep'
import { getDefaultAloMailTemplate, AloMailTemplate } from '@/models/alo/AloMailTemplate';
import { toStringDictionary } from '@/utils/groupBy';
import { getDefaultAloMailTemplateLg } from '@/models/alo/AloMailTemplateLg';


@Component({
  name: 'EditBaseMailTemplate',    
  components:{EditDrawer}, 
  props: {
    title:String,            
    width:{
      type:String,
      default:"1200"
    },
    saveLabel:{
      type:String,
      default:"Sauvegarder"
    }
  } 
})
export default class EditBaseMailTemplate extends Vue {
  
  private original:AloMailTemplate = getDefaultAloMailTemplate()
  private modified:AloMailTemplate = getDefaultAloMailTemplate()
  private showDrawer = false
  private saving = false
    
  edit(item:AloMailTemplate, addMissingLang = false) {
    this.$store.myActions.ADM_MAIL_TEMPLATE_RESET_STATUS()
    this.showDrawer = true
    this.original = {...getDefaultAloMailTemplate(),...item}    
    this.modified = cloneDeep(this.original)

    if(addMissingLang) {
      //verification que toutes les langues sont bien présente on ajoute les manquantes
      const lgDic = toStringDictionary(this.modified.lgs,it => it.lg)
      this.configuration.langs.forEach(lg => {
        if(!lgDic[lg]) this.modified.lgs.push(getDefaultAloMailTemplateLg(lg))
      })
    }

    return this.modified
  }
  
  get configuration(){
    return this.$store.myGetters.configuration
  }

  get isDirty() {
    return !deepEqual(this.original,this.modified)
  }

  get mailTemplateStatus() {
    return this.$store.myGetters.mailTemplateStatus        
  }

  saveData() {    
    if ((this.$refs.editForm as HTMLFormElement).validate()) {
      this.saving = true
      this.$store.myActions.ADM_MAIL_TEMPLATE_SAVE_REQUEST(this.modified).then(() => {
        this.$store.myActions.UI_ADD_SNACK_MESSAGE(this.mailTemplateStatus)          
        this.showDrawer = false
      }).finally(()=>{
        this.saving = false
      })    
    } 
  }

}
